import repository from './repsitory'

const resource = '/shippingType'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addShippingType (data) {
        return repository.post(`${resource}`, data)
    },
    updateShippingType (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
